<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title>
    <app-offcanvas-header-btn [title]="title"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    <div class="cards-dropdown-offset-wrapper immediate">
      <p class="form-label">Which card would you like to top up?</p>
      @if (cardTopupsService.isLoading()) {
        <p class="text-muted">Loading cards...</p>
      } @else {
        <ng-select
          class="cards-dropdown"
          [(ngModel)]="selectedCardId"
          (ngModelChange)="getCardBalance()"
          [searchable]="true"
          [clearable]="false"
          notFoundText="No cards available"
          placeholder="Search card name or type">
          @if (cardsList().length > 0) {
            @for (item of cardsList(); track item.id) {
              <ng-option [value]="item.id">
                <app-ng-select-card-dropdown-options [item]="item"></app-ng-select-card-dropdown-options>
              </ng-option>
            }
          }
        </ng-select>
      }

      @if (this.selectedCardId) {
        <div class="card card-sm border-input mt-2">
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <div class="text-gray-500 text-sm">Card balance:</div>
                <div class="text-lg fw-semibold">
                  @if (this.cardBalance()) {
                    {{ cardBalance() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
                  } @else if (cardBalanceError()) {
                    <i
                      class="iconoir-warning-circle text-warning"
                      title="Could not fetch card balance"></i>
                  }
                </div>
                @if (this.cardBalanceLoading()) {
                  <div class="spinner-border spinner-border-sm text-secondary">
                    <span class="visually-hidden">Loading ...</span>
                  </div>
                }
              </div>
              <div class="col-8">
                <div class="text-gray-500 text-sm">Card number:</div>
                <div class="text-lg fw-semibold">
                  {{ cardNumber() | emptyIndicator }}
                </div>
              </div>
            </div>
            <div class="card-subtitle"></div>
          </div>
        </div>

        @if (this.selectedCardId) {
          <p class="form-label mt-3">What would you like to do?</p>
          <div class="row mb-1">
            @for (option of selectOptions; track option.value) {
              <div class="col">
                <div class="form-check input-radio-select input-radio-select-right">
                  <input
                    class="form-check-input"
                    [checked]="option.checked"
                    (change)="onSelectOption(option.value)"
                    type="radio"
                    name="optionFields"
                    [id]="'option_' + option.value" />
                  <label
                    class="form-check-label"
                    [ngClass]="{ 'border-secondary': option.checked }"
                    [for]="'option_' + option.value">
                    <i [ngClass]="option.icon"></i>
                    {{ option.label }}
                  </label>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
    @if (this.selectedCardId) {
      @if (getSelectedOption()?.value === CardFundType.Load) {
        <app-immediate-top-up-load-form
          class="offset-form"
          [selectedCardId]="selectedCardId"
          [cardBalance]="cardBalance()"
          [cardBalanceError]="cardBalanceError()"
          (submitSuccess)="handleSubmitSuccess()"></app-immediate-top-up-load-form>
      } @else if (getSelectedOption()?.value === CardFundType.Deduct) {
        <app-immediate-top-up-deduct-form
          class="offset-form"
          [isLoadFunds]="false"
          [selectedCardId]="selectedCardId"
          [cardBalance]="cardBalance()"
          [cardBalanceError]="cardBalanceError()"
          (submitSuccess)="handleSubmitSuccess()"></app-immediate-top-up-deduct-form>
      }
    }
  </ng-container>
</app-offcanvas-base>
